import {
  DateField,
  useRecordContext,
  useTranslate,
} from 'react-admin';
import type { RaRecord } from 'ra-core';
import { Chip } from '@mui/material';
import { calculateDaysUntilExpiry, certificationExpiryChipColor, getCertificationExpiryText } from '../utils/certificationsAnsItemsExpiry';

type ExpiryRow = RaRecord & { expiryDate?: string; largestReminderPeriodInDays: number };

type CertificationExpiryWithDaysCaptionProps = {
  record?: ExpiryRow;
};

export const CertificationExpiryWithDaysCaption = (
  props: CertificationExpiryWithDaysCaptionProps & { label?: string },
) => {

  const translate = useTranslate();
  const rowFromContext = useRecordContext<ExpiryRow>();
  const row = props.record ?? rowFromContext;
  if (!row?.expiryDate) {

    return null;

  }
  const days = calculateDaysUntilExpiry(row.expiryDate);

  const label = getCertificationExpiryText(days, translate);

  return (
    <div
      style={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        textAlign: 'center',
        gap: '2px',
      }}
    >
      <DateField
        record={row}
        source="expiryDate"
        label={false}
      />
      <Chip
        label={label}
        color={certificationExpiryChipColor(days, row.largestReminderPeriodInDays)}
        variant="outlined"
        size="small"
      />
    </div>
  );

};
